import React from 'react';
import { ArticleData } from '@benzinga/article-manager';
import { NodeLayout } from '@benzinga/content-manager';
import Hooks, { NoFirstRender } from '@benzinga/hooks';
import { ArticleBlocks } from './ArticleBlocks';
import { EditorBox } from './Widgets/EditorBox';

export const ArticleLayoutHeader: React.FC<{
  articleData: ArticleData;
  baseUrl?: string;
  isEditor: boolean;
  layout?: NodeLayout | null;
  isMobile?: boolean;
  enableBlocks?: boolean;
  useNewTemplate?: boolean;
}> = ({ articleData, baseUrl, enableBlocks, isEditor, isMobile, layout, useNewTemplate }) => {
  const [isEditorModeEnabled] = Hooks.useLocalStorage('editor_mode_enabled', false);
  const isEditorModeEnabledHydrated = Hooks.useHydrate(isEditorModeEnabled, false);

  const canonicalUrl =
    (`${baseUrl ? baseUrl : 'https://www.benzinga.com'}/${articleData.canonicalPath}` ||
      articleData?.metaProps?.canonical?.toString()) ??
    '';

  return (
    <>
      {enableBlocks && layout?.header?.blocks && <ArticleBlocks blocks={layout.header.blocks} />}
      {isEditorModeEnabledHydrated && isEditor && !isMobile && articleData.nodeId && (
        <NoFirstRender>
          <React.Suspense>
            <EditorBox
              canonicalUrl={canonicalUrl}
              nid={articleData.nodeId}
              postId={articleData?.meta?.wp_post_meta?.post_id}
              title={articleData?.title}
              type={articleData?.meta?.wp_post_meta?.post_type}
              useNewTemplate={useNewTemplate}
            />
          </React.Suspense>
        </NoFirstRender>
      )}
    </>
  );
};
